const TitleTextSection = ({ title, subtitle }) => {
   return (
     <div className="pl-1 my-4">
       <h2 className="text-xl sm:text-2xl md:text-3xl font-black text-white uppercase tracking-wider">
         {title}
       </h2>
       {subtitle && (
         <h3 className="text-xs sm:text-sm font-medium text-stone-400 mt-1">{subtitle}</h3>
       )}
     </div>
   );
 };

export default TitleTextSection;
